import styled, {css} from 'styled-components'

const Style = {
	ModalBackground: styled.div`
		position: fixed;
		top: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100vw;
		height: 100dvh;
		background-color: rgba(0, 0, 0, 0.6);
		z-index: 99999999;

		${({$upper}) =>
			$upper &&
			css`
				z-index: 999999999;
			`}
	`,
	Modal: styled.div`
		width: fit-content;
		min-width: 400px;
		height: fit-content;
		display: flex;
		flex-direction: column;
		padding: 40px 24px;
		gap: 24px;
		background-color: ${({theme}) => theme.color.white};
		border-radius: 20px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			min-width: 300px;
			width: 90%;
			padding: 40px 24px 24px;
			max-height: 90dvh;
			overflow: auto;
		}
	`,
	TitleDiv: styled.div`
		display: flex;
		justify-content: space-between;
		align-items: center;

		h2 {
			width: 100%;
			${({theme}) => theme.font.large_bold};
			text-align: center;
		}

		button {
			width: 12px;
			height: 12px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	`,
}

export default Style
